import { Pipe, PipeTransform } from '@angular/core';
import { formatDistance } from 'date-fns';

@Pipe({
  name: 'timeAgo',
  standalone: true,
})
export class TimeAgoPipe implements PipeTransform {
  transform(date: string | Date): string {
    return formatDistance(new Date(date), new Date(), { addSuffix: true });
  }
}
